import { BackgroundInfoData } from './types'

export const getTotalAspSavings = (backgroundInfoData: BackgroundInfoData | undefined): number => {
  const firstApplicantAspSavings = backgroundInfoData?.aspAmount
  const secondApplicantAspSavings = backgroundInfoData?.secondApplicant?.aspAmount

  return (firstApplicantAspSavings ?? 0) + (secondApplicantAspSavings ?? 0)
}
